import { render, staticRenderFns } from "./Lgx184766243515924480.vue?vue&type=template&id=5d5a5157&"
import script from "./Lgx184766243515924480.vue?vue&type=script&lang=js&"
export * from "./Lgx184766243515924480.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports